import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import styled from "styled-components"
import moment from "moment"

//Notification Status Badges
//Agency
import OrderPlacedIcon from "assets/images/notification-bell/agency/Order Placed.svg"
import OrderProcessingIcon from "assets/images/notification-bell/agency/Order Processing.svg"
import OutForDeliveryIcon from "assets/images/notification-bell/agency/Out for Delivery.svg"
import AgencyOrderDeliveredIcon from "assets/images/notification-bell/agency/Order Delivered.svg"
import OrderCancelledIcon from "assets/images/notification-bell/agency/Order Cancelled.svg"
import ReturnOrderIcon from "assets/images/notification-bell/agency/Return Order.svg"
import ApprovedIcon from "assets/images/notification-bell/agency/Approved badge.svg"
//Merchant
import LowStockIcon from "assets/images/notification-bell/merchant/low-stock.svg"
import NoStockIcon from "assets/images/notification-bell/merchant/no-stock.svg"
import MerchantOrderDeliveredIcon from "assets/images/notification-bell/merchant/order-delivered.svg"
import MerchantApprovedIcon from "assets/images/notification-bell/merchant/Approved badge.svg"
import MerchantPaymentReceivedIcon from "assets/images/notification-bell/merchant/Payment Received.svg"
import MerchantPaymentReleasedIcon from "assets/images/notification-bell/merchant/Payment Released.svg"
import MerchantPaymentOnProcessIcon from "assets/images/notification-bell/merchant/Payment On Process.svg"
//Admin
// --

// Components
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//i18n
import { withTranslation } from "react-i18next"

// REDUX
import { useSelector, useDispatch } from "storeRtk"
import {
  getNotifications,
  updateNotifications,
} from "slices/agency-notifications" // agency
import {
  getMerchantNotifications,
  updateMerchantNotifications,
} from "slices/merchant-notifications" // merchant

//ENUMS
import { orderStatusENUMS } from "constants/agency"

const role = JSON.parse(localStorage.getItem("authUser"))?.role_type

const NotificationDropdown = props => {
  // VARIABLES
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { agencyNotificationsArr } = useSelector(
    state => state.agencyNotificationsSlice
  )
  const { merchantNotificationsArr } = useSelector(
    state => state.merchantNotificationsSlice
  )
  const scrollableNodeRef = useRef()
  const [notifData, setNotifData] = useState([])
  const [notifDataLimit3, setNotifDataLimit3] = useState([])
  const [menu, setMenu] = useState(false)

  // FUNCTIONS
  const handleGetAgencyNotifications = () => {
    dispatch(getNotifications())
  }

  const handleGetMerchantNotifications = () => {
    dispatch(getMerchantNotifications())
  }

  useEffect(() => {
    // On Mount GET notifications
    if (role === "Agency") {
      // console.log(`${role ?? "--"} On Mount GET Notif`)
      handleGetAgencyNotifications()
      // return () => clearInterval(notifInterval)
    } else if (role === "Merchant") {
      // console.log(`${role ?? "--"} On Mount GET Notif`)
      handleGetMerchantNotifications()
    } else {
      // console.log(`${role ?? "--"} On Mount GET Notif`)
    }
  }, [role])

  useEffect(() => {
    // Trigger Interval

    let notifInterval
    if (role === "Agency") {
      // console.log(`${role ?? "--"} Notifications Agency Interval Activated`)
      notifInterval = setInterval(handleGetAgencyNotifications, 10000) // 10secs previously 2sec
      // return () => clearInterval(notifInterval)
    } else if (role === "Merchant") {
      // console.log(`${role ?? "--"} Notifications Merchant Interval Activated`)
      notifInterval = setInterval(handleGetMerchantNotifications, 10000) // 2secs previously 2sec
    } else {
      // console.log(`${role ?? "--"} Notifications is not available`)
    }

    // Clean Up
    return () => {
      // console.log("Notif Interval Deactivated")
      clearInterval(notifInterval)
    }
  }, [])

  useEffect(() => {
    if (role === "Agency") {
      const filteredAgencyNotificationsArr = agencyNotificationsArr.filter(
        notif => notif?.attributes?.read === false
      )

      const showOnly3NotifsInContainer = filteredAgencyNotificationsArr.slice(
        0,
        3
      )

      // console.log("AGENCY NOTIFICATIONS: ", filteredAgencyNotificationsArr)
      setNotifDataLimit3(showOnly3NotifsInContainer)
      setNotifData(filteredAgencyNotificationsArr)
    } else if (role === "Merchant") {
      const filteredMerchantNotificationsArr = merchantNotificationsArr.filter(
        notif => notif?.attributes?.read === false
      )

      const showOnly3NotifsInContainer = filteredMerchantNotificationsArr.slice(
        0,
        3
      )

      // console.log("MERCHANT NOTIFICATIONS: ", filteredMerchantNotificationsArr)
      setNotifDataLimit3(showOnly3NotifsInContainer)
      setNotifData(filteredMerchantNotificationsArr)
    }
  }, [agencyNotificationsArr, merchantNotificationsArr])

  const transformOrderStatus = (
    orderStatus,
    orderId,
    agencyName,
    isLowStock,
    isNoStock,
    isDelivered,
    merchantNotifIsReceived,
    merchantNotifIsReleased,
    merchantNotifIsOnProcess,
    merchantNotifIsOrderApproved
  ) => {
    if (role === "Agency") {
      if (orderStatus === "pending") {
        return `Your order no. ${orderId} is placed`
      } else if (orderStatus === "order_processing") {
        return `Your order no. ${orderId} is being processed`
      } else if (orderStatus === "out_for_delivery") {
        return `Your order no. ${orderId} is being delivered`
      } else if (orderStatus === "delivered") {
        return `Your order no. ${orderId} has been delivered`
      } else if (orderStatus === "cancelled") {
        return `Your order no. ${orderId ?? "--"} has been cancelled`
      } else if (orderStatus === "approved") {
        return `Your order no. ${orderId ?? "--"} has been approved`
      } else {
        return "Resource not found. 404 API error"
      }
    } else if (role === "Merchant") {
      if (orderStatus === "pending") {
        return `${agencyName} placed an order`
      } else if (orderStatus === "order_processing") {
        return `${agencyName} is being processed`
      } else if (orderStatus === "out_for_delivery") {
        return `${orderId} is being delivered`
      } else if (orderStatus === "delivered") {
        return `${agencyName} has been delivered`
      } else if (orderStatus === "cancelled") {
        return `Your order no. ${orderId} has been cancelled`
      } else if (merchantNotifIsOrderApproved) {
        return `Your order no. ${orderId ?? "--"} has been approved`
      } else if (isLowStock) {
        return "Your product is now on minimum"
      } else if (isNoStock) {
        return "Your product is now out of stock"
      } else if (isDelivered) {
        return `Your order no. ${orderId ?? "--"} has been delivered`
      } else if (merchantNotifIsReceived) {
        return `The payment has been received by the admin.`
      } else if (merchantNotifIsReleased) {
        return `The payment has been released by the admin.`
      } else if (merchantNotifIsOnProcess) {
        return `The payment is being processed by the admin.`
      } else {
        return "Resource not found. 404 API error"
      }
    }
  }

  const getNotifBadge = (
    orderStatus,
    isLowStock,
    isNoStock,
    isDelivered,
    merchantNotifIsReceived,
    merchantNotifIsReleased,
    merchantNotifIsOnProcess,
    merchantNotifIsOrderApproved
  ) => {
    if (role === "Agency") {
      if (orderStatus === "pending") {
        return OrderPlacedIcon // Your order is placed
      } else if (orderStatus === "order_processing") {
        return OrderProcessingIcon //Your order is being processed
      } else if (orderStatus === "out_for_delivery") {
        return OutForDeliveryIcon //Your order is being delivered
      } else if (orderStatus === "delivered") {
        return AgencyOrderDeliveredIcon //Your order has been delivered
      } else if (orderStatus === "cancelled") {
        return OrderCancelledIcon //Your order has been cancelled
      } else if (orderStatus === "return_item") {
        return ReturnOrderIcon //Your order is being returned
      } else if (orderStatus === "approved") {
        return ApprovedIcon // Your order has been approved
      } else {
        return "bx-error-alt" // Resource not found. 404 API error
      }
    } else if (role === "Merchant") {
      if (orderStatus === "pending") {
        return OrderPlacedIcon // placed an order
      } else if (orderStatus === "order_processing") {
        return OrderProcessingIcon //Your order is being processed FUTURE RELEASE
      } else if (orderStatus === "out_for_delivery") {
        return OutForDeliveryIcon //Your order is being delivered FUTURE RELEASE
      } else if (orderStatus === "cancelled") {
        return OrderCancelledIcon //Your order has been cancelled FUTURE RELEASE
      } else if (merchantNotifIsOrderApproved) {
        return MerchantApprovedIcon //Order has been approved
      } else if (orderStatus === "return_item") {
        return ReturnOrderIcon //Your order is being returned FUTURE RELEASE
      } else if (isLowStock) {
        return LowStockIcon // Your product is now on minimum
      } else if (isNoStock) {
        return NoStockIcon // Your product is now out of stock
      } else if (isDelivered) {
        return MerchantOrderDeliveredIcon //Your order has been delivered FUTURE RELEASE
      } else if (merchantNotifIsReceived) {
        return MerchantPaymentReceivedIcon // Payment has been received
      } else if (merchantNotifIsReleased) {
        return MerchantPaymentReleasedIcon // Payment has been released
      } else if (merchantNotifIsOnProcess) {
        return MerchantPaymentOnProcessIcon // Payment is being process
      } else {
        return "bx-error-alt" // Resource not found. 404 API error
      }
    }
  }

  const getNotifBadgeColor = (orderStatus, isLowStock, isNoStock) => {
    if (orderStatus === "pending") {
      return "warning" // Your order is placed
    } else if (orderStatus === "order_processing") {
      return "warning" //Your order is being processed
    } else if (orderStatus === "out_for_delivery") {
      return "primary" //Your order is being delivered
    } else if (orderStatus === "delivered") {
      return "primary" //Your order has been delivered
    } else if (orderStatus === "cancelled") {
      return "danger" //Your order has been cancelled
    } else if (orderStatus === "return_item") {
      return "danger" //Your order is being returned
    } else if (isLowStock) {
      return "primary" // Your product is now on minimum
    } else if (isNoStock) {
      return "danger" // Your product is now out of stock
    } else {
      return "danger" // Resource not found. 404 API error
    }
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        {/* -----------------THE BELL ICON----------------- 👇*/}
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i
            className={`bx bx-bell${notifData.length > 0 ? " bx-tada" : ""}`} //dynamic bell animation
          />
          {notifData.length > 0 && (
            <BadgeCounter className="badge bg-danger rounded-pill">
              {notifData.length}
            </BadgeCounter>
          )}
        </DropdownToggle>

        {/* -----------------CONTENT TITLE----------------- 👇*/}
        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 mb-2"> {props.t("Notifications")} </h6>
              </Col>
              {/* <div className="col-auto">
                <a href="#" className="small">
                  View All
                </a>
              </div> */}
            </Row>
          </div>

          {/* -----------------CONTENT BODY----------------- 👇 */}
          <StyledSimplebar
            scrollableNodeProps={{ ref: scrollableNodeRef }}
            isnodata={String(notifData?.length)}
            role={role}
          >
            {notifData?.length === 0 ? (
              <NoNotificationsWrapper>No Data Available</NoNotificationsWrapper>
            ) : (
              notifDataLimit3.map((notif, index) => {
                if (notif?.attributes?.read === false) {
                  return (
                    <NotificationItem
                      key={index}
                      // to={`/agency/order-status/${notif?.attributes?.data?.order_id}`}
                      className="text-reset notification-item"
                    >
                      <NotificationRow>
                        <NotifCol>
                          {/* ------------ DYNAMIC BADGE ------------ 👇*/}
                          <NotifBadgeWrapper className="avatar-xs">
                            {orderStatusENUMS.includes(
                              notif?.attributes?.data?.order_status
                            ) ? (
                              <img
                                src={getNotifBadge(
                                  notif?.attributes?.data?.order_status ?? "", // orderStatus
                                  notif?.attributes?.data?.type === "low_stock", // product in minimum stock
                                  notif?.attributes?.data?.type === "no_stock", // product in minimum stock
                                  notif?.attributes?.data?.type === "delivered", // order has been delivered
                                  notif?.attributes?.data?.type ===
                                    "received" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved", // Payment has been received
                                  notif?.attributes?.data?.type ===
                                    "released" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved", // Payment has been released
                                  notif?.attributes?.data?.type ===
                                    "on_process" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved", // Payment is being processed
                                  notif?.attributes?.data?.type ===
                                    "approved" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved" // Your order has been approved
                                )}
                                alt="notifBadge"
                                width="32"
                                height="32"
                              />
                            ) : (
                              <NotificationBadge
                                className={`avatar-title bg-${getNotifBadgeColor(
                                  notif?.attributes?.data?.order_status,
                                  notif?.attributes?.data?.type === "low_stock", // product in minimum stock
                                  notif?.attributes?.data?.type === "no_stock", // product in minimum stock
                                  notif?.attributes?.data?.type === "delivered", // order has been delivered
                                  notif?.attributes?.data?.type ===
                                    "received" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved", // Payment has been received
                                  notif?.attributes?.data?.type ===
                                    "released" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved", // Payment has been released
                                  notif?.attributes?.data?.type ===
                                    "on_process" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved", // Payment is being processed
                                  notif?.attributes?.data?.type ===
                                    "approved" &&
                                    notif?.attributes?.data?.order_status ===
                                      "approved" // Your order has been approved
                                )} rounded-circle font-size-16`}
                              >
                                <i className={`bx bx-error-alt`} />
                              </NotificationBadge>
                            )}
                          </NotifBadgeWrapper>
                        </NotifCol>
                        <NotifCol type="description">
                          <div className="flex-grow-1">
                            <NotificationTitle className="mt-0 mb-1">
                              {transformOrderStatus(
                                notif?.attributes?.data?.order_status ?? "--", //orderStatus
                                notif?.attributes.data?.order_id ?? "--", //orderId
                                notif?.attributes?.data?.agency_department ??
                                  "--", //agencyName
                                notif?.attributes?.data?.type === "low_stock", // product in minimum stock
                                notif?.attributes?.data?.type === "no_stock", // product in minimum stock
                                notif?.attributes?.data?.type === "delivered", // order has been delivered
                                notif?.attributes?.data?.type === "received" &&
                                  notif?.attributes?.data?.order_status ===
                                    "approved", // Payment has been received
                                notif?.attributes?.data?.type === "released" &&
                                  notif?.attributes?.data?.order_status ===
                                    "approved", // Payment has been released
                                notif?.attributes?.data?.type ===
                                  "on_process" &&
                                  notif?.attributes?.data?.order_status ===
                                    "approved", // Payment is being processed
                                notif?.attributes?.data?.type === "approved" &&
                                  notif?.attributes?.data?.order_status ===
                                    "approved" // Your order has been approved
                              )}
                            </NotificationTitle>
                            <TypographyDescAndTime className="font-size-12 text-muted">
                              <NotificationDescription
                                className="mb-1"
                                onClick={() => {
                                  {
                                    /* ------------ DYNAMIC REDIRECTION AND READ NOTIF ------------ 👇*/
                                  }
                                  if (role === "Agency") {
                                    // Redirect to Order Status Details
                                    navigate(
                                      `/agency/order-status/${notif?.attributes?.data?.order_id}`,
                                      { state: { notificationId: notif?.id } }
                                    )
                                    dispatch(
                                      updateNotifications({
                                        id: notif?.id,
                                        data: { read: true },
                                      })
                                    )
                                  } else if (role === "Merchant") {
                                    if (
                                      notif?.attributes?.data?.type ===
                                      "low_stock"
                                    ) {
                                      // Redirect to Order Status Details
                                      navigate(
                                        `/merchant/products/${notif?.attributes?.data?.product?.id}/edit`,
                                        {
                                          state: {
                                            notificationId: notif?.id,
                                          },
                                        }
                                      )
                                    } else {
                                      // Redirect to Order Status Details
                                      navigate(
                                        `/merchant/pending-order/${notif?.attributes?.data?.order_id}`,
                                        { state: { notificationId: notif?.id } }
                                      )
                                    }

                                    // Read Notif
                                    // console.log(
                                    //   "TRIGGERED READ NOTIF (PUT): ",
                                    //   notif?.id
                                    // )
                                    dispatch(
                                      updateMerchantNotifications({
                                        id: notif?.id,
                                        data: { read: true },
                                      })
                                    )
                                  }

                                  // Close dropdown
                                  setMenu(false)
                                }}
                              >
                                {/* ------------ DYNAMIC DESCRIPTION TEXT ------------ 👇*/}
                                {role === "Agency"
                                  ? "Click here to view your order status."
                                  : role === "Merchant" &&
                                    notif?.attributes?.data?.type ===
                                      "low_stock"
                                  ? "Click here to add more stocks."
                                  : role === "Merchant"
                                  ? "Click here to view the agency order."
                                  : "Click here to view."}
                              </NotificationDescription>
                              <NotificationTime>
                                <i
                                  className="mdi mdi-clock-outline"
                                  style={{ marginRight: "5px" }}
                                />
                                {notif?.attributes?.updated_at
                                  ? moment(notif?.attributes?.updated_at)
                                      .local()
                                      .fromNow()
                                  : "--"}
                              </NotificationTime>
                            </TypographyDescAndTime>
                          </div>
                        </NotifCol>
                      </NotificationRow>
                    </NotificationItem>
                  )
                } else {
                  return ""
                }
              })
            )}
          </StyledSimplebar>

          {/* -----------------CONTENT FOOTER----------------- 👇 */}
          {notifData?.length > 3 && (
            <div className="p-2 border-top d-grid">
              <Link
                className="btn btn-sm btn-link font-size-14 text-center"
                to={`/${role?.toLowerCase()}/notifications`}
                onClick={() => setMenu(!menu)}
              >
                <i className="mdi mdi-arrow-right-circle me-1" />{" "}
                <span key="t-view-more">{props.t("View More..")}</span>
              </Link>
            </div>
          )}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}

// STYLED COMPONENTS 👇
const BadgeCounter = styled.span``

const NoNotificationsWrapper = styled.div`
  text-align: center;
`
const StyledSimplebar = styled(SimpleBar)`
  height: ${props =>
    props.isnodata === "0"
      ? "30px"
      : props.isnodata === "1"
      ? "90px"
      : props.isnodata === "2"
      ? "180px"
      : props.isnodata === "3"
      ? "270px"
      : props.isnodata === "0" && role === "Merchant"
      ? "40px"
      : props.isnodata === "1" && role === "Merchant"
      ? "100px"
      : props.isnodata === "2" && role === "Merchant"
      ? "190px"
      : props.isnodata === "3" && role === "Merchant"
      ? "280px"
      : "270px"};
  .simplebar-content-wrapper {
    box-sizing: content-box !important;
  }
  //
`
// const NotificationItem = styled(Link)``
const NotificationItem = styled.div``

const NotificationRow = styled.div`
  display: flex;
`
const NotifCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.type === "description" ? "start" : "center")};
  width: ${props => (props.type === "description" ? "300px" : "75px")};
`
const NotifBadgeWrapper = styled.div`
  min-width: 10px;
`
const NotificationBadge = styled.span``
const NotificationTitle = styled.h6`
  font-weight: 600;
  color: #2b2b2b !important;
  padding-right: 20px;
`

const TypographyDescAndTime = styled.div`
  padding-right: 50px;
`
const NotificationDescription = styled.p`
  color: #313d85 !important;
  font-weight: 500;
  cursor: pointer;
`
const NotificationTime = styled.p`
  margin-bottom: 7px;
`

// NOTIFICATION MATRICES: 👇
// BE      |      FE
// pending = "Order Placed" 👈 means approved by admin in Admin > Agency Orders Page
// order_processing = "On Process" 👈 means status is updated in Merchant > Active Orders Page
// out_for_delivery = "To Receive" 👈 means status is updated in Merchant > Active Orders Page
// delivered = "Delivered" 👈 means status is updated in Merchant > Active Orders Page
// cancelled = "Cancelled" 👈 means status is cancelled/decline in Agency > Order Status Page (order placed | pero wla pa to sa needs) & Admin > Agency Orders (decline)
// return_item = "Return Item" 👈 means status is updated in Agency > Order Status Page

//BACKUP 👇

{
  /* <NotificationBadge
                              className={`avatar-title bg-${getNotifBadgeColor(
                                // notif?.attributes?.order_id?.status
                                notif?.attributes?.data?.order_status
                              )} rounded-circle font-size-16`}
                            >
                              <i
                                className={`bx ${getNotifBadge(
                                  // notif?.attributes?.order_id?.status
                                  notif?.attributes?.data?.order_status
                                )}`}
                              />
                            </NotificationBadge> */
}

// const getNotifBadge = orderStatus => {
//   if (orderStatus === "pending") {
//     return "bx-cart" // Your order is placed
//   } else if (orderStatus === "order_processing") {
//     return "bx-box" //Your order is being processed
//   } else if (orderStatus === "out_for_delivery") {
//     return "bx-car" //Your order is being delivered
//   } else if (orderStatus === "delivered") {
//     return "bx-badge-check" //Your order has been delivered
//   } else {
//     return "bx-error-alt" // Resource not found. 404 API error
//   }
// }
